import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Image } from 'react-native';
import { useTranslation } from 'react-i18next';
import { languageService } from '../services';

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  // Taal veranderen als je op een vlaggetje klikt.
  // Dit herlaadt de teksten in de app direct.
  const handleLanguageChange = async (language: 'nl' | 'en') => {
    try {
      await languageService.setLanguage(language);
    } catch (error) {
      console.error('Kon taal niet veranderen:', error);
    }
  };

  return (
    <View style={stijlen.container}>
      <TouchableOpacity
        style={[stijlen.button, currentLanguage === 'nl' && stijlen.activeButton]}
        onPress={() => handleLanguageChange('nl')}>
        <Image
          source={{ uri: '/assets/flags/nl.png' }}
          style={stijlen.flagIcon}
        />
        <Text style={[stijlen.buttonText, currentLanguage === 'nl' && stijlen.activeButtonText]}>
          NL
        </Text>
      </TouchableOpacity>
      <TouchableOpacity
        style={[stijlen.button, currentLanguage === 'en' && stijlen.activeButton]}
        onPress={() => handleLanguageChange('en')}>
        <Image
          source={{ uri: '/assets/flags/gb.png' }}
          style={stijlen.flagIcon}
        />
        <Text style={[stijlen.buttonText, currentLanguage === 'en' && stijlen.activeButtonText]}>
          EN
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const stijlen = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 8,
  },
  button: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 8,
    backgroundColor: '#F5F5F5',
    borderWidth: 1,
    borderColor: '#E0E0E0',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 6,
  },
  activeButton: {
    backgroundColor: '#7B3FF2',
    borderColor: '#7B3FF2',
  },
  flagIcon: {
    width: 20,
    height: 15,
    borderRadius: 2,
  },
  buttonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#666',
  },
  activeButtonText: {
    color: '#FFFFFF',
  },
});

export default LanguageSelector;
